import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlightTravellers from 'components/widgets/flightTravellers';
import FlightRoundTrip from 'components/widgets/engines/flightRoundTrip';
import FlightOneway from 'components/widgets/engines/flightOneway';
import FlightOpenJaw from 'components/widgets/engines/flightOpenJaw';
import FlightMultiCity from 'components/widgets/engines/flightMultiCity';
import FlightCarriers from 'components/widgets/autocompletes/flightCarriers';
import buildQueryString from 'helpers/buildQueryString';
import ErrorHandler from 'libraries/errorHandler';
import moment from 'moment';

class Flights extends Component {
    constructor(props) {
        super(props);
        const stateValue = {
            legs: [{
                key: '1',
                startDate: null,
                endDate: null,
                departure: null,
                destination: null,
            }, {
                key: '2',
                startDate: null,
                endDate: null,
                departure: null,
                destination: null,
            }],
            travellers: {
                adults: 1,
                children: [],
            },
            trip: 'roundtrip',
            showTravellers: false,
            cabin: '',
            changesAllowed: '',
            maxConnections: 2,
            carriers: [],
            nearByAirport: false,
            atLeastFreeBaggage: false,
            multicityPricing: false,
            basicEconomyFares: false,
            airFare: true,
            landFare: false,
            cruiseFare: false,
            Traveltoken: props.Traveltoken,
            TravelRedirect: props.TravelRedirect,
        };

        const storage = localStorage.getItem('flightEngine');
        try {
            if (storage !== null && storage.length > 0) {
                Object.assign(stateValue, JSON.parse(storage));

                stateValue.legs = stateValue.legs.map((leg) => {
                    const newLeg = Object.assign({}, leg);

                    if (leg.endDate !== null) {
                        newLeg.endDate = moment(leg.endDate);
                    }

                    if (leg.startDate !== null) {
                        newLeg.startDate = moment(leg.startDate);
                    }

                    return newLeg;
                });
                if (stateValue.date !== null) {
                    stateValue.date = moment(stateValue.date);
                }
            }
        } catch (e) {
            localStorage.removeItem('flightEngine');
        }

        this.state = stateValue;

        const rules = {
            'form.departure': (departure) => {
                let valid = true;

                if (departure === null || Object.keys(departure).length === 0) {
                    valid = 'Select a departure';
                }

                return valid;
            },

            'form.destination': (destination) => {
                let valid = true;

                if (destination === null || Object.keys(destination).length === 0) {
                    valid = 'Select a destination';
                }

                return valid;
            },
            'travellers.childAge': (age, key, index) => {
                let valid = true;

                if (age === '') {
                    valid = `child ${index + 1} in room ${key + 1} needs an age`;
                }
                return valid;
            },
            'form.dates': (dates) => {
                let valid = true;
                if (dates.depDate === null || dates.retDate === null) {
                    valid = 'Please selected a valid departure and return date';
                }
                return valid;
            },
            'form.date': (date) => {
                let valid = true;
                if (date === null) {
                    valid = 'Please selected a valid travel date';
                }
                return valid;
            },
        };

        this.errorHandler = new ErrorHandler(rules);

        this.toggleTravellers = this.toggleTravellers.bind(this);
        this.handleTravellerBlur = this.handleTravellerBlur.bind(this);
        this.changeTrip = this.changeTrip.bind(this);
        this.changeTravellers = this.changeTravellers.bind(this);
        this.legChanged = this.legChanged.bind(this);
        this.swapLocations = this.swapLocations.bind(this);
        this.changeCabin = this.changeCabin.bind(this);
        this.changeItems = this.changeItems.bind(this);
        this.selectCarriers = this.selectCarriers.bind(this);
        this.changePanClude = this.changePanClude.bind(this);
        this.changeFareType = this.changeFareType.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleTravellerBlur(event) {
        let node = event.target;

        let within = false;

        while (node !== event.currentTarget) {
            node = node.parentNode;

            if (node.classList.contains('htl_popover')) {
                within = true;
                break;
            }
        }

        if (!within) {
            this.hideTravellers();
        }
    }

    toggleTravellers(occupancyOpen) {
        if (occupancyOpen) {
            this.showTravellers();
        } else {
            this.hideTravellers();
        }
    }

    hideTravellers() {
        const app = document.getElementById('app');
        app.removeEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: false });
    }

    showTravellers() {
        const app = document.getElementById('app');
        app.addEventListener('click', this.handleTravellerBlur);

        this.setState({ showTravellers: true });
    }

    changeTravellers(travellers) {
        this.setState({ travellers });
    }

    legChanged(legs, element) {
        const { shouldValidate, trip } = this.state;

        // check validation before updating state
        if (shouldValidate) {
            const parts = element.split('-');
            const leg = legs.find((option) => option.key === parts[1]);

            if (parts.length === 2) {
                if (parts[0] === 'departure') {
                    this.errorHandler.checkRule(`form.departure-${leg.key}`, leg.departure);
                } else if (parts[0] === 'destination') {
                    this.errorHandler.checkRule(`form.destination-${leg.key}`, leg.destination);
                } else if (parts[0] === 'date') {
                    if (trip === 'roundtrip') {
                        this.errorHandler.checkRule(`form.dates-${leg.key}`, { depDate: leg.startDate, retDate: leg.endDate });
                    } else {
                        this.errorHandler.checkRule(`form.date-${leg.key}`, leg.startDate);
                    }
                }
            } else {
                this.errorHandler.clear(`form.departure-${element}`);
                this.errorHandler.clear(`form.destination-${element}`);
                this.errorHandler.clear(`form.date-${element}`);
            }
        }

        this.setState({ legs });
    }

    changeTrip(event) {
        const { legs } = this.state;
        const { target } = event;

        if (target.value === 'roundtrip') {
            legs.forEach((leg, index) => {
                this.errorHandler.clear(`form.date-${leg.key}`);
                if (index > 0) {
                    this.errorHandler.clear(`form.departure-${leg.key}`);
                    this.errorHandler.clear(`form.destination-${leg.key}`);
                }
            });
        } else if (target.value === 'oneway') {
            legs.forEach((leg, index) => {
                if (index > 0) {
                    this.errorHandler.clear(`form.date-${leg.key}`);
                    this.errorHandler.clear(`form.departure-${leg.key}`);
                    this.errorHandler.clear(`form.destination-${leg.key}`);
                } else {
                    this.errorHandler.clear(`form.dates-${leg.key}`);
                }
            });
        } else if (target.value === 'openjaw') {
            legs.forEach((leg, index) => {
                this.errorHandler.clear(`form.date-${leg.key}`);
                this.errorHandler.clear(`form.departure-${leg.key}`);
                this.errorHandler.clear(`form.destination-${leg.key}`);
            });
        } else if (target.value === 'multicity') {
            this.errorHandler.clear(`form.dates-${legs[0].key}`);
        }

        this.setState({ trip: target.value });
    }

    swapLocations(index) {
        const { legs } = this.state;

        const newLeg = Object.assign({}, legs[index]);

        newLeg.departure = legs[index].destination;
        newLeg.destination = legs[index].departure;

        const newLegs = [...legs.splice(0, index), newLeg, ...legs.splice(index + 1)];

        this.setState({ legs: newLegs });
    }

    changeCabin(event) {
        const { target } = event;
        this.setState({ cabin: target.value });
    }

    changeItems(item, event) {
        const { value } = event.target;

        if (item === 'changesAllowed') {
            const { changesAllowed } = this.state;
            this.setState({ changesAllowed: value });
        } else if (item === 'maxConnections') {
            const { maxConnections } = this.state;
            this.setState({ maxConnections: value });
        }
    }

    selectCarriers(value) {
        this.setState({ carriers: value });
    }

    changePanClude(item) {
        if (item === 'nearByAirport') {
            const { nearByAirport } = this.state;
            this.setState({ nearByAirport: !nearByAirport });
        } else if (item === 'atLeastFreeBaggage') {
            const { atLeastFreeBaggage } = this.state;
            this.setState({ atLeastFreeBaggage: !atLeastFreeBaggage });
        } else if (item === 'multicityPricing') {
            const { multicityPricing } = this.state;
            this.setState({ multicityPricing: !multicityPricing });
        } else if (item === 'basicEconomyFares') {
            const { basicEconomyFares } = this.state;
            this.setState({ basicEconomyFares: !basicEconomyFares });
        }
    }

    changeFareType(fareType) {
        if (fareType === 'air') {
            const { airFare } = this.state;
            this.setState({ airFare: !airFare });
        } else if (fareType === 'land') {
            const { landFare } = this.state;
            this.setState({ landFare: !landFare });
        } else if (fareType === 'cruise') {
            const { cruiseFare } = this.state;
            this.setState({ cruiseFare: !cruiseFare });
        }
    }

    submit(flag, event) {
        event.preventDefault();
        const {
            travellers,
            carriers,
            trip,
            cabin,
            legs,
            Traveltoken,
            TravelRedirect,
        } = this.state;

        travellers.children.forEach((age, index) => {
            this.errorHandler.checkRule(`travellers.childAge-${index}`, age);
        });

        if (trip === 'roundtrip') {
            this.errorHandler.checkRule(`form.departure-${legs[0].key}`, legs[0].departure);
            this.errorHandler.checkRule(`form.destination-${legs[0].key}`, legs[0].destination);
            this.errorHandler.checkRule(`form.dates-${legs[0].key}`, { depDate: legs[0].startDate, retDate: legs[0].endDate });
        } else if (trip === 'oneway') {
            this.errorHandler.checkRule(`form.departure-${legs[0].key}`, legs[0].departure);
            this.errorHandler.checkRule(`form.destination-${legs[0].key}`, legs[0].destination);
            this.errorHandler.checkRule(`form.date-${legs[0].key}`, legs[0].startDate);
        } else if (trip === 'openjaw') {
            this.errorHandler.checkRule(`form.departure-${legs[0].key}`, legs[0].departure);
            this.errorHandler.checkRule(`form.destination-${legs[0].key}`, legs[0].destination);
            this.errorHandler.checkRule(`form.date-${legs[0].key}`, legs[0].startDate);
            this.errorHandler.checkRule(`form.departure-${legs[1].key}`, legs[1].departure);
            this.errorHandler.checkRule(`form.destination-${legs[1].key}`, legs[1].destination);
            this.errorHandler.checkRule(`form.date-${legs[1].key}`, legs[1].startDate);
        } else if (trip === 'multicity') {
            legs.forEach((leg) => {
                this.errorHandler.checkRule(`form.departure-${leg.key}`, leg.departure);
                this.errorHandler.checkRule(`form.destination-${leg.key}`, leg.destination);
                this.errorHandler.checkRule(`form.date-${leg.key}`, leg.startDate);
            });
        }

        const errors = this.errorHandler.getErrors();

        if (Object.keys(errors).length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
        } else {
            const params = {};
            const fares = [];
            const carrierValue = [];

            if (this.state.airFare) fares.push('air');
            if (this.state.landFare) fares.push('land');
            if (this.state.cruiseFare) fares.push('cruise');

            params.fareTypes = fares.join(':');
            params.adultCount = travellers.adults;

            params.infantCount = 0;

            /**
            * Count infants from children
            */
            travellers.children.forEach(
                (item) => {
                    if (item == '<1' || item == '0' || item == '') {
                        params.infantCount += 1;
                    }
                },
            );

            params.childCount = travellers.children.length - params.infantCount;

            params.cabin = this.state.cabin;
            params.atLeastFreeBaggage = this.state.atLeastFreeBaggage;
            params.maxConnections = this.state.maxConnections;
            params.nearByAirport = this.state.nearByAirport;
            params.multicityPricing = this.state.multicityPricing;
            params.basicEconomyFares = this.state.basicEconomyFares;
            params.changesAllowed = this.state.changesAllowed;

            /**
            * Get carriers
            */
            carriers.forEach(
                (item) => {
                    if (item.hasOwnProperty('value')) {
                        carrierValue.push(item.value);
                    }
                },
            );

            params.carriers = carrierValue.join(':');

            params.preferredAirlines = '';

            // params.flexibleDate = false;
            if (flag === 'flexibleDate') params.flexibleDate = true;

            const leg = legs[0];

            params.flyingFromCode = leg.departure.id;
            params.flyingToCode = leg.destination.id;
            params.departDate = leg.startDate.format('YYYY-MM-DDTHH:mm:ss');

            if (trip === 'roundtrip') {
                params.returnDate = leg.endDate.format('YYYY-MM-DDTHH:mm:ss');
                params.tripType = 'Return';
            } else if (trip === 'oneway') {
                params.tripType = 'OneWay';
            } else if (trip === 'openjaw') {
                params.flyingFromCode_1 = legs[1].departure.id;
                params.flyingToCode_1 = legs[1].destination.id;
                params.departDate_1 = legs[1].startDate.format('YYYY-MM-DDTHH:mm:ss');
                params.tripType = 'OpenJaw';
            } else if (trip === 'multicity') {
                for (let i = 1; i < 6 && i < legs.length; i++) {
                    if (legs[i].hasOwnProperty('departure') && legs[i].hasOwnProperty('destination')
                         && legs[i].hasOwnProperty('startDate') && legs[i].hasOwnProperty('departTime')) {
                        params[`flyingFromCode_${i}`] = legs[i].departure.id;
                        params[`flyingToCode_${i}`] = legs[i].destination.id;
                        params[`departDate_${i}`] = legs[i].startDate.format('YYYY-MM-DDTHH:mm:ss');
                    }
                }

                params.tripType = 'MultiCity';
            }

            // console.log(JSON.stringify(params));

            const queryString = buildQueryString(params);
            const url = `https://secure.redtag.ca/resvflt/flights/search?${queryString}`;
            window.location.href = url;

            const storage = {
                legs,
                trip,
                travellers,
                carriers,
            };

            localStorage.setItem('flightEngine', JSON.stringify(storage));

            // const url = TravelRedirect+"/?t=" + Traveltoken;
            // window.location.href = url;
        }

        return false;
    }

    render() {
        const {
            legs,
            cabin,
            trip,
            travellers,
            showTravellers,
            changesAllowed,
            maxConnections,
            carriers,
            nearByAirport,
            atLeastFreeBaggage,
            multicityPricing,
            basicEconomyFares,
            airFare,
            landFare,
            cruiseFare,
        } = this.state;

        const errors = this.errorHandler.getErrors();

        return (
            <form className="search-flight" action="">
                <input type="hidden" name="request" value="" />
                <div className="row gutter-10 mb-3">
                    <div className="">
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-roundtrip" name="trip" value="roundtrip" onChange={this.changeTrip} checked={trip === 'roundtrip'} />
                            <label htmlFor="radio-roundtrip"><span>Round Trip</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-oneway" name="trip" value="oneway" onChange={this.changeTrip} checked={trip === 'oneway'} />
                            <label htmlFor="radio-oneway"><span>One Way</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-openjaw" name="trip" value="openjaw" onChange={this.changeTrip} checked={trip === 'openjaw'} />
                            <label htmlFor="radio-openjaw"><span>Open Jaw</span></label>
                        </div>
                        <div className="styled-radio black-text">
                            <input type="radio" id="radio-multicity" name="trip" value="multicity" onChange={this.changeTrip} checked={trip === 'multicity'} />
                            <label htmlFor="radio-multicity"><span>Multi-Cities</span></label>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 mb-3 mb-md-0">
                    {(trip === 'roundtrip' && (
                        <FlightRoundTrip legs={legs} errors={errors.form} onChange={this.legChanged} swapLocations={this.swapLocations} />
                    )) || (trip === 'oneway' && (
                        <FlightOneway legs={legs} errors={errors.form} onChange={this.legChanged} swapLocations={this.swapLocations} />
                    )) || (trip === 'openjaw' && (
                        <FlightOpenJaw legs={legs} errors={errors.form} onChange={this.legChanged} swapLocations={this.swapLocations} />
                    )) || (trip === 'multicity' && (
                        <FlightMultiCity legs={legs} errors={errors.form} onChange={this.legChanged} swapLocations={this.swapLocations} />
                    ))}
                    <div className="col-12 col-md-6 col-lg-6 col-xxl-3 cabin-rooms">
                        <div className="element-container">
                            <div className="row gutter-0">
                                <div className="col">
                                    <div className="select-unstyled-container">
                                        <label className="text-label" htmlFor="">Cabin</label>
                                        <select className="w-100 select-unstyled" id="cruise_duration" value={cabin} onChange={this.changeCabin}>
                                            <option value="0">Economy</option>
                                            <option value="2">Premium Economy</option>
                                            <option value="1">Business Class</option>
                                            <option value="3">First Class</option>
                                        </select>
                                        <svg className="icon icon-select" aria-hidden="true">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="col">
                                    <FlightTravellers travellers={travellers} onChange={this.changeTravellers} errors={errors.travellers} visible={showTravellers} onVisibilityChange={this.toggleTravellers} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 col-xxl-2 room-guest">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="">Changes allowed</label>
                            <select id="" className="w-100 select-unstyled" value={changesAllowed} onChange={(e) => this.changeItems('changesAllowed', e)}>
                                <option value="both">Both</option>
                            </select>
                            <svg className="icon icon-btn" aria-hidden="true" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <use xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 col-xxl-2 room-guest">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="">Maximum connections</label>
                            <select id="" className="w-100 select-unstyled" value={maxConnections} onChange={(e) => this.changeItems('maxConnections', e)}>
                                <option value="0">Direct Flights</option>
                                <option value="1">1 Maximum</option>
                                <option value="2">2 Maximum</option>
                                <option value="3">3 Maximum</option>
                            </select>
                            <svg className="icon icon-btn" aria-hidden="true" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <use xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xxl-2 room-guest">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="flt_carriers">Carriers</label>
                            <FlightCarriers
                                id="flt_carriers"
                                placeholder="Select carriers"
                                onSelect={(value) => this.selectCarriers(value)}
                                value={carriers}
                            />
                            <svg className="icon icon-btn" aria-hidden="true" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <use xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xxl-2 ml-xl-4">
                        <label className="text-label font-weight-bold text-dark" htmlFor="">Includes</label>
                        <div className="">
                            <div className="styled-checkbox font-weight-500 mb-1">
                                <input type="checkbox" id="inclusive_1" checked={nearByAirport} onChange={() => this.changePanClude('nearByAirport')} />
                                <label htmlFor="inclusive_1">
                                    <span>Search nearby airport</span>
                                </label>
                            </div>
                            <div className="styled-checkbox font-weight-500 mb-1">
                                <input type="checkbox" id="inclusive_2" checked={atLeastFreeBaggage} onChange={() => this.changePanClude('atLeastFreeBaggage')} />
                                <label htmlFor="inclusive_2">
                                    <span>Atleast 1 free bag</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xxl-2">
                        <label className="text-label font-weight-bold text-dark" htmlFor="">Exclude</label>
                        <div className="">
                            <div className="styled-checkbox font-weight-500 mb-1">
                                <input type="checkbox" id="exclusive_1" checked={multicityPricing} onChange={() => this.changePanClude('multicityPricing')} />
                                <label htmlFor="exclusive_1">
                                    <span>Multi-ticket pricing</span>
                                </label>
                            </div>
                            <div className="styled-checkbox font-weight-500 mb-1">
                                <input type="checkbox" id="exclusive_2" checked={basicEconomyFares} onChange={() => this.changePanClude('basicEconomyFares')} />
                                <label htmlFor="exclusive_2">
                                    <span>Basic Economy Fares</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 mb-2">
                    <div className="col-auto">
                        <span className="font-weight-bold text-dark">Fare Types</span>
                    </div>
                </div>
                <div className="row gutter-10 mb-3">
                    <div className="col-auto">
                        <div className="styled-checkbox font-weight-500">
                            <input type="checkbox" id="fares_1" checked={airFare} onChange={() => this.changeFareType('air')} />
                            <label htmlFor="fares_1">
                                <span>Air</span>
                            </label>
                        </div>
                        <div className="styled-checkbox font-weight-500">
                            <input type="checkbox" id="fares_2" checked={landFare} onChange={() => this.changeFareType('land')} />
                            <label htmlFor="fares_2">
                                <span>Land</span>
                            </label>
                        </div>
                        <div className="styled-checkbox font-weight-500">
                            <input type="checkbox" id="fares_3" checked={cruiseFare} onChange={() => this.changeFareType('cruise')} />
                            <label htmlFor="fares_3">
                                <span>Cruise</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 border-top mt-2">
                    <div className="col-12 text-center mt-2 mt-2 pt-2">
                        <button type="button" className="btn btn-primary btn-lg px-5 font-weight-600 mx-md-2" onClick={(e) => this.submit('', e)}>
                            <span className="">Search</span>
                            <span className="font-size-sm d-block">+/- 3 days</span>
                        </button>
                        {
                            (trip === 'roundtrip' || trip === 'oneway')
                                ? (
                                    <button type="button" className="btn btn-warning btn-lg mt-2 mt-sm-0 text-white px-5 mx-md-2 border-0" onClick={(e) => this.submit('flexibleDate', e)}>
                                        {/* <span className="">Search<br/>+/- 3 days</span> */}
                                        <span className="">Search<br /></span>

                                    </button>
                                ) : null
                        }
                    </div>
                </div>
            </form>
        );
    }
}

export default Flights;
